import { useCart } from "@kupikupi/api";
import { useAuthToken } from "./auth";

/**
 * Cart-count badge source of truth (mirrors the web app's `useCartCount`).
 * The header cart button reads from here so the badge can never drift from the
 * real cart. Returns 0 when there's no auth token so the badge hides instead of
 * showing a fake count for a logged-out shell.
 *
 * Wires to real `itemCount` (backend `shopCartItemCount` from /shopCart/listV3),
 * the same `useCart` query the cart page consumes — so TanStack dedupes the
 * fetch and the badge updates the moment an add/edit/delete invalidates it.
 */
export function useCartCount(): number {
  const authToken = useAuthToken();
  const { data } = useCart(authToken);
  return data?.itemCount ?? 0;
}
